import { useEvent } from "@/context/EventContext";
import { CalendarDays, Eye } from "lucide-react";

const PHASES = [
  { key: "pre_event", label: "Before" },
  { key: "live_event", label: "Live" },
  { key: "post_event", label: "After" },
];

export default function PhaseBanner() {
  const { event, realPhase, effectivePhase, demoPhase, setDemoPhase } = useEvent();
  if (!event) return null;

  const fmt = (d) => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short" });
  const phaseLabel = { pre_event: "Before the show", live_event: "Live now", post_event: "After the show" }[effectivePhase];

  return (
    <div className="glass rounded-2xl px-4 py-3 mb-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3" data-testid="phase-banner">
      <div className="flex items-center gap-2.5">
        <div className="h-9 w-9 rounded-xl btn-gold flex items-center justify-center shrink-0">
          <CalendarDays size={17} className="text-[#26210F]" />
        </div>
        <div className="leading-tight">
          <div className="text-sm font-semibold text-slate-100">{event.name} · {fmt(event.start_date)}–{fmt(event.end_date)}</div>
          <div className="text-[11px] text-slate-400">
            {phaseLabel}
            {demoPhase && <span className="ml-1 text-[var(--jjs-gold-deep)] font-semibold" data-testid="demo-phase-indicator">· TEST MODE (simulated phase)</span>}
          </div>
        </div>
      </div>
      <div className="flex items-center gap-1.5" data-testid="demo-phase-switch">
        <Eye size={13} className="text-slate-400 mr-1" />
        {PHASES.map((p) => {
          const active = effectivePhase === p.key;
          const isReal = realPhase === p.key && !demoPhase;
          return (
            <button
              key={p.key}
              data-testid={`demo-phase-${p.key}`}
              onClick={() => setDemoPhase(p.key === realPhase ? null : p.key)}
              aria-pressed={active}
              className={`text-[11px] px-2.5 py-1 rounded-full border transition ${active ? "btn-gold border-transparent" : "glass text-slate-400 border-amber-500/20"}`}
              title={isReal ? "Current real phase" : "Preview only"}
            >
              {p.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
